export const DELETE_TENANT_MUTATION = `
  mutation ($ids: [Int!]!) {
    deleteTenant(ids: $ids)
  }
`;

export type DeleteTenantResponse = {
  deleteTenant: Array<number>
}
